import { List, SquareKanban, Grid3x3 } from 'lucide-react';
import { cn } from '@/lib/utils';

export type TaskView = 'list' | 'board' | 'compact';

interface ViewToggleProps {
  view: TaskView;
  onViewChange: (view: TaskView) => void;
  /** Which views to offer; defaults to list + board. */
  options?: TaskView[];
}

const OPTIONS: { value: TaskView; icon: typeof List; title: string }[] = [
  { value: 'list', icon: List, title: 'List view' },
  { value: 'board', icon: SquareKanban, title: 'Board view' },
  { value: 'compact', icon: Grid3x3, title: 'Compact view' },
];

export function ViewToggle({ view, onViewChange, options = ['list', 'board'] }: ViewToggleProps) {
  return (
    <div className="flex gap-1 bg-grey-100 p-1 rounded-lg inline-flex">
      {OPTIONS.filter((o) => options.includes(o.value)).map(({ value, icon: Icon, title }) => (
        <button
          key={value}
          onClick={() => onViewChange(value)}
          className={cn(
            'px-3 py-2 rounded transition-colors flex items-center gap-2',
            view === value
              ? 'bg-accent text-white'
              : 'bg-transparent text-grey-600 hover:bg-grey-200'
          )}
          title={title}
        >
          <Icon className="w-4 h-4" />
        </button>
      ))}
    </div>
  );
}
